import { Component, EventEmitter, Input, OnInit, Output, TemplateRef } from '@angular/core';
import { BootstrapSemanticVariation } from '@app/utils/bootstrap';

@Component({
  selector: 'portal-bulk-action-dialog-header',
  templateUrl: './bulk-action-dialog-header.component.html',
  styles: [],
  standalone: false,
})
export class BulkActionDialogHeaderComponent implements OnInit {
  @Output()
  dismiss = new EventEmitter<void>();

  @Input()
  header: TemplateRef<any>;

  @Input()
  variant!: BootstrapSemanticVariation;

  constructor() {}

  ngOnInit(): void {}
}
